/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createFOAsyncThunk } from '../../helpers/thunk.helpers';
import draftApi from '../../../api/draft.api';

/**
 * Retrieves fees configuration from submission-service and sends it to configuration.slice
 * Use as a template for external configurations which are not in fo-configuration
 * @type {AsyncThunk<*, void, {}>}
 */
export const getFeesThunk = createFOAsyncThunk('configuration/getFees', async (arg) => {
  const { configResource, procedure } = arg;
  const response = await draftApi.getFees();

  // return must map exactly the same as the return from the generic fetchResource thunk from configuration.thunk.js
  return { name: configResource.name, procedure, value: response };
});
